export default __webpack_public_path__ + "static/media/icons8-react.0a7cffca.gif";